import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/monorepo/monorepo/apps/website/components/form-service/sections/BreederContent.tsx");
